import app from '../../admin/app';
import SettingsModal from './SettingsModal';
export default class EditCustomHeaderModal extends SettingsModal {
  className() {
    return 'EditCustomHeaderModal TextareaCodeModal Modal--large';
  }
  title() {
    return app.translator.trans('core.admin.edit_header.title');
  }
  form() {
    return [m("p", null, app.translator.trans('core.admin.edit_header.customize_text')), m("div", {
      className: "Form-group"
    }, m("textarea", {
      className: "FormControl",
      rows: "30",
      bidi: this.setting('custom_header')
    }))];
  }
  onsaved() {
    window.location.reload();
  }
}
flarum.reg.add('core', 'admin/components/EditCustomHeaderModal', EditCustomHeaderModal);